import type { SxProps, Theme } from "@mui/material/styles";

/** Matches packages/frontend MainNavbar inner width (invite landing navbar + footer). */
export const LANDING_SHELL_MAX_WIDTH_PX = 1200;

export const landingShellContainerSx: SxProps<Theme> = {
  maxWidth: LANDING_SHELL_MAX_WIDTH_PX,
  mx: "auto",
  px: { xs: "1.25rem", md: 4 },
};

/** Same max width as Forgot/Reset password and sign-in (`AuthCard` narrow layout). */
export const AUTH_CARD_MAX_WIDTH_PX = 400;

/** Outer column: fills Layout auth shell above footer (no viewport-height overflow). */
export const authShellSx: SxProps<Theme> = {
  bgcolor: "background.default",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  width: "100%",
};

/** Centers card content vertically with top offset below navbar. */
export const authCenterColumnSx: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  py: 4,
  pt: 12,
};
